import { PERMISSIONS } from '@core/constants/permissions.constants';
import { ReportConfig } from './sparepart-report.config';

export const PROCUREMENT_REPORT_CONFIG: ReportConfig = {
  id: 'procurement',
  title: 'Procurement Report',
  permissions: {
    view: PERMISSIONS.GSE.REPORTS.PROCUREMENT.VIEW,
    export: PERMISSIONS.GSE.REPORTS.PROCUREMENT.EXPORT,
  },
  filters: [
    {
      type: 'text',
      field: 'search',
      label: 'Search',
      placeholder: 'Search',
    },
    {
      type: 'date-range',
      field: 'dateRange',
      label: 'Date Range',
      placeholder: 'Date range',
    },
    {
      type: 'dropdown',
      field: 'pettyCash',
      label: 'Petty Cash',
      placeholder: 'Petty Cash',
      multiselect: false,
    },
  ],

  columns: [
    {
      field: 'purchaseReqId',
      header: 'Purchase Request ID',
      type: 'text',
      width: '14%',
    },
    {
      field: 'prDate',
      header: 'PR Date',
      type: 'text',
      pipes: ['date'],
      width: '12%',
    },
    {
      field: 'spareParts',
      header: 'Spare Parts',
      type: 'text',
      width: '28%',
    },
    {
      field: 'vendors',
      header: 'Vendors',
      type: 'text',
      width: '28%',
    },
    {
      field: 'pettyCash',
      header: 'Petty Cash',
      type: 'text',
      width: '18%',
    },
  ],
};
